import { render, staticRenderFns } from "./order-invoice-template2.vue?vue&type=template&id=19fe42bc"
import script from "./order-invoice-template2.vue?vue&type=script&lang=js"
export * from "./order-invoice-template2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports